import React from "react";
import {
  useTranslate,
} from "@refinedev/core";
import {
  Typography,
  Stack,
  Paper,
} from "@mui/material";
import { IContact } from "@/utils/zod/contactFormValidation";
import { ShowField } from "../show/Field";

interface ContactShowContentProps {
  contact: IContact;
}

export const ContactShowContent: React.FC<ContactShowContentProps> = ({ contact }) => {
  const t = useTranslate();

  return (
    <Stack spacing="32px" padding="32px 32px 56px 32px">

      {/* Contact Info */}
      <Stack spacing="24px">
        <Typography variant="h5">{contact.name}</Typography>

        <Paper>
          {/* Category */}
          <ShowField title={t("accounts.fields.name")} value={(contact.name && contact.user?.name) ? `${contact.name} (${contact.user?.name})` : contact.name ? contact.name : contact.user?.name ? `(${contact.user?.name})` : ""} />

          {/* Phone Number */}
          <ShowField title={t("accounts.fields.phone_number")} value={contact.user?.phone_number?.toString() || ""} />

          {/* Role Permission */}
          <ShowField title={t("accounts.fields.role_permission_name")} value={contact.role_permission_name || ""} />

          {/* Companies */}
          <ShowField title={t("accounts.fields.company")} value={[contact.company_ledger_name || ""]} chipStatus="neutral" chipType="company" />

          {/* Status */}
          <ShowField title={t("accounts.fields.status.label")} value={[contact.status]} chipStatus={contact.status === "approved" ? "positive" : contact.status === "banned" ? "negative" : "neutral"} chipType="status" />

          {/* Created At */}
          <ShowField title={t("accounts.fields.createdAt")} value={contact.inserted_at?.toString() || ""} chipType="date" />
        </Paper>
      </Stack>
    </Stack>
  );
};